// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "../css/" + ({"114":"rating-plugins","158":"tab-plugins","176":"tablesorter-plugins","454":"imagealbum-plugins","581":"fancybox","991":"slideshow-plugins"}[chunkId] || chunkId) + ".css";
};